import React from "react";
import { useContext } from "react";
import { WindowContext } from "../../context/WindowContext";
import AddBikePageImg from "../../assets/add-bike-page-img.png"

export default function AddBikePage () {
    
    let {modalState, toggleModalState} = useContext(WindowContext)

    // Shows Add Bike Modal
    const handleAddBikeBtn = () => {
        if (modalState.addBikeNewModal === false) {
                toggleModalState("addBikeNewModal")
            }
    }

    return (
        <>
            <div className="main-fallback-wr">
                <div className="fallback-wr">
                    <img className="fallback-page-img" src={AddBikePageImg}/>
                    <p className="text-center">Get started by adding your bike! If we have your model on our database, we’ll be able to provide you with specs from the manafacture.</p>
                    <button className="primary-btn" onClick={handleAddBikeBtn}>Add New Bike</button>
                </div>
            </div>
        </>
    )
}

